var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_111",
    "data-name": "Group 111",
    transform: "translate(-4489.5 -3634.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_109",
    "data-name": "Group 109"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_60",
    "data-name": "Rectangle 60",
    width: 24,
    height: 24,
    rx: 5.333,
    transform: "translate(4490 3635)",
    fill: "#191d29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M4508.667,3659.5h-13.334a5.839,5.839,0,0,1-5.833-5.833v-13.334a5.839,5.839,0,0,1,5.833-5.833h13.334a5.839,5.839,0,0,1,5.833,5.833v13.334A5.839,5.839,0,0,1,4508.667,3659.5Zm-13.334-24a4.838,4.838,0,0,0-4.833,4.833v13.334a4.838,4.838,0,0,0,4.833,4.833h13.334a4.838,4.838,0,0,0,4.833-4.833v-13.334a4.838,4.838,0,0,0-4.833-4.833Z",
    fill: "#3d4463"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_110",
    "data-name": "Group 110"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M4502.274,3652.638a.724.724,0,0,0,.232-.154l3.674-3.674a.716.716,0,1,0-1.012-1.013l-2.452,2.452v-8.226a.716.716,0,1,0-1.432,0v8.226l-2.452-2.452a.716.716,0,1,0-1.012,1.013l3.674,3.674a.718.718,0,0,0,.78.154Z",
    fill: "#8a8fb5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_61",
    "data-name": "Rectangle 61",
    width: 15.273,
    height: 15.273,
    transform: "translate(4509.637 3639.364) rotate(90)",
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon-download.23d1cc1549ad9d0cb8d42b4ebfca379a.svg";
export { ForwardRef as ReactComponent };